import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetDeploymentFrequencyRate from "shared/DoraMetrics/useGetDeploymentFrequencyRate";

import useDoraDateRange from "../useDateRange";

const useDoraDeploymentFrequencyRate = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { rate, loading, error, networkStatus } = useGetDeploymentFrequencyRate({
    startTimeUnix: getUnixTime(startTime),
    endTimeUnix: getUnixTime(endTime),
  });

  const isLoading =
    (loading && typeof rate === "undefined") || networkStatus === NetworkStatus.refetch;

  return {
    rate,
    isLoading,
    error,
  };
};

export default useDoraDeploymentFrequencyRate;
